import { SideMenuTopic } from '@/const/SideMenuTopic'

/**
 * 先生用サイドメニューに表示する項目の定義
 */
export namespace TeacherSideMenuTopic {
  /** 教室生徒一覧 */
  export const STUDENT_LIST: Topic = {
    text: '生徒管理',
    icon: '/img/icon/manage/sidemenu/student_list.svg',
    url: '/teacher/students',
  }

  /** 生徒進捗確認画面 */
  export const STUDENT_PROGRESS: Topic = {
    text: '生徒進捗確認',
    icon: '/img/icon/manage/sidemenu/student_list.svg',
    url: '/teacher/students/progress/general',
    subUrls: ['/teacher/students/progress/map', '/teacher/students/.*/progress', '/teacher/students/.*/map'],
  }

  /** 通常学習進捗比較 */
  export const COMPARE_LEARNING_PROGRESS: Topic = {
    text: '通常学習進捗比較',
    icon: '/img/icon/manage/sidemenu/compare_general_learning_progress.svg',
    url: '/teacher/course/progress',
    subUrls: ['/teacher/class/progress'],
  }

  /** マニュアル */
  const MANUAL: Topic = {
    text: 'マニュアル',
    icon: '/img/icon/student/sidemenu/map.svg',
    url: '/teacher/manual',
    target: '_blank',
  }

  /** メニュー項目一覧 */
  export const LIST: Topic[] = [STUDENT_LIST, STUDENT_PROGRESS, COMPARE_LEARNING_PROGRESS, MANUAL]

  /** メニュー項目の型 */
  export type Topic = SideMenuTopic.Topic
}
